import { render } from "./Talk.vue?vue&type=template&id=43dab3a7"
import script from "./Talk.vue?vue&type=script&lang=js"
export * from "./Talk.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./Talk.vue?vue&type=style&index=0&id=43dab3a7&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__